// Analytics API service for v0.6.0

import type { AnalyticsResponse, AnalyticsQuery } from '../types';

const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

/**
 * Get member analytics data
 */
export async function getMemberAnalytics(
  query?: AnalyticsQuery
): Promise<AnalyticsResponse> {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('未登入');
  }

  const params = new URLSearchParams();
  if (query?.startDate) params.append('startDate', query.startDate);
  if (query?.endDate) params.append('endDate', query.endDate);

  const url = `${API_BASE}/api/member/analytics${params.toString() ? `?${params}` : ''}`;

  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: { message: '未知錯誤' } }));
    throw new Error(error.error?.message || '取得分析資料失敗');
  }

  return response.json();
}

/**
 * Export analytics as CSV
 */
export async function exportAnalytics(query?: AnalyticsQuery): Promise<Blob> {
  const token = localStorage.getItem('auth_token');
  if (!token) {
    throw new Error('未登入');
  }

  const params = new URLSearchParams();
  if (query?.startDate) params.append('startDate', query.startDate);
  if (query?.endDate) params.append('endDate', query.endDate);

  const url = `${API_BASE}/api/member/analytics/export${params.toString() ? `?${params}` : ''}`;

  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('匯出失敗');
  }

  return response.blob();
}

/**
 * Download analytics CSV file
 */
export async function downloadAnalyticsCSV(
  query?: AnalyticsQuery
): Promise<void> {
  const blob = await exportAnalytics(query);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `analytics_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
